import { handleService } from './common'
const prefix = '/api/Account'

const url = {
  getListByPage: prefix + '/GetListByPage',
  addAccount: prefix + '/Add',
  getInfo: prefix + '/Get',
  update: prefix + '/Update',
  delete: prefix + '/Delete'
}
export default {
  GetAccountTable (data) {
    return handleService(url.getListByPage, data)
  },

  AddAccount (data) {
    return handleService(url.addAccount, data, 'post')
  },

  GetInfo (data) {
    return handleService(url.getInfo, data)
  },

  UpdateAccount (data) {
    return handleService(url.update, data, 'put')
  },

  Delete (data) {
    return handleService(url.delete, data, 'delete')
  }
}
